import { render, staticRenderFns } from "./PengecekanAntrianTruck.vue?vue&type=template&id=5b499c56&scoped=true"
import script from "./PengecekanAntrianTruck.vue?vue&type=script&lang=js"
export * from "./PengecekanAntrianTruck.vue?vue&type=script&lang=js"
import style0 from "./PengecekanAntrianTruck.vue?vue&type=style&index=0&id=5b499c56&prod&lang=css"
import style1 from "./PengecekanAntrianTruck.vue?vue&type=style&index=1&id=5b499c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b499c56",
  null
  
)

export default component.exports